import React, { useMemo } from 'react'
import './MeetingOverallSentiment.scss'
import { colorMap, TimelineItem } from './model'
import { ApexOptions } from 'apexcharts'
import Chart from 'react-apexcharts'

export type SentimentGlobalTrendChartProps = {
  timeline: TimelineItem[]
  width: number | string
  height: number | string
}

export const SentimentTrendChart: React.FC<SentimentGlobalTrendChartProps> = ({ timeline, width = 500, height = 250 }) => {
  const getColor = (value: number) => {
    if (value >= 0 && value < 5) {
      return colorMap.negative
    } else if (value >= 5.5) {
      return colorMap.positive
    } else {
      return colorMap.neutral
    }
  }
  const chartData = useMemo(() => {
    return {
      chart: {
        type: 'area',
        series: [
          {
            data: timeline.map(({ timestamp, avgSentiment }: { timestamp: number; avgSentiment: number }) => [timestamp, avgSentiment]),
          },
        ],
        options: {
          chart: {
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          height: 230,
          foreColor: 'red',
          colors: ['#5227CC'],
          stroke: {
            width: 2,
          },
          grid: {
            show: true,
            borderColor: '#455455',
            clipMarkers: false,
            yaxis: {
              lines: {
                show: false,
              },
            },
          },
          dataLabels: {
            enabled: false,
          },
          fill: {
            gradient: {
              enabled: true,
              opacityFrom: 0.55,
              opacityTo: 0,
            },
          },
          markers: {
            discrete: timeline.map((point, index) => ({
              seriesIndex: 0,
              dataPointIndex: index,
              fillColor: getColor(point.avgSentiment),
              strokeColor: getColor(point.avgSentiment),
              size: 4,
            })),
          },
          tooltip: {
            enabled: false,
            theme: 'dark',
          },
          xaxis: {
            type: 'datetime',
            axisBorder: {
              show: false,
            },
            labels: {
              show: false,
            },
          },
          yaxis: {
            labels: {
              show: false,
            },
            min: 0,
            tickAmount: 3,
          },
        } as ApexOptions,
      },
    }
  }, [timeline])

  return (
    <div>
      <Chart width={width} height={height} {...chartData.chart} type='area' />
    </div>
  )
}
